import * as React from "react";

import { Box } from "@mui/material";

import CustomButton from "../../../../helper-components/input/CustomButton";
import CustomSelection from "../../../../helper-components/form/CustomSelection";

import { querySelectLibraries } from "../../../../helper-functions/api/libraryQueries";
import { getEllipsis } from "../../../../helper-functions/shared/miscUtils";

import { getLanguage } from "../../../../config/language/language";

/**
 * Pick one library, or several when multiselect is set.
 * The confirm button reports the chosen library ids.
 */
export default function LibraryPickForm(props) {
    const { callback, multiselect = false, confirmTitle } = props;
    const [selected, setSelected] = React.useState([]);

    const handleClick = () => {
        if (!selected.length) {
            props.showSnackbar({ message: getLanguage().SNACKBAR_ERROR_LIBRARY_REQUIRED, color: "error" });
            return;
        }

        const libraryIds = multiselect ? selected.map((library) => library.id) : [selected[0].id];
        callback(true, { libraryIds, libraryId: selected[0].id });
    };

    return (
        <Box className="box">
            <CustomSelection
                {...props}
                multiselect={multiselect}
                callback={setSelected}
                query={querySelectLibraries}
                getPrimarySearchText={(el) => el?.name}
                getSecondarySearchText={(el) => el?.description}
                getPrimaryText={(el) => getEllipsis(el?.name, 50)}
                getSecondaryText={(el) => getEllipsis(el?.description, 50)}
            />

            <CustomButton {...props} title={confirmTitle} onClick={handleClick} className="button" fullWidth />
        </Box>
    );
}
